import reset from "styled-reset";
import { createGlobalStyle } from "styled-components";
import { getLocalStorageWithExpiry } from "../../locales/langFunc";
import "./Globalfonts.css";

const lang = getLocalStorageWithExpiry("i18nextLng");
let font;
if (lang === "ko") {
  font = "Noto Sans KR";
} else if (lang === "en") {
  font = "Noto Sans";
} else if (lang === "ja") {
  font = "Noto Sans JP";
} else {
  font = "Noto Sans";
}

const Globalstyle = createGlobalStyle`
${reset}
div ,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;  
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
a {
  color: inherit;
  text-decoration: none;
}

* {
  box-sizing: border-box;
}

body {
  font-family: ${font}, sans-serif;
  background-color: #f7f9fc; /* 매우 밝은 회색 톤 */
  color: #333;
  margin: 0;
  padding: 0;
  position: relative;
  overflow-x: hidden; /* 가로 스크롤 방지 */
  
  /* 은은한 배경 효과 추가 */
  background: linear-gradient(120deg, rgba(247, 249, 252, 1) 0%, rgba(220, 228, 236, 1) 100%);
  box-shadow: inset 0 1px 5px rgba(0, 0, 0, 0.05);

  /* 좌측 상단 효과 */
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 40%;
    height: 40%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.2), transparent 100%);
    opacity: 0.5;
    pointer-events: none; /* 상호작용 차단 */
    z-index: 0; /* 콘텐츠보다 뒤에 오도록 설정 */
  }

  /* 우측 하단 효과 */
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    width: 40%;
    height: 40%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.2), transparent 100%);
    opacity: 0.5;
    pointer-events: none;
    z-index: 0;
  }
}


/* 전체 DatePicker 팝업의 스타일 */
.react-datepicker {
  font-family: 'Noto Sans', sans-serif;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  background-color: #fff;
  padding: 10px;
  display: inline-flex;
  width: fit-content;
}

.react-datepicker__month-container {
  min-width: 500px; /* 날짜 선택 영역 확장 */
}

.react-datepicker__time-container {
  width: 30%;
  min-width: 150px; /* 시간 선택 영역을 줄임 */
  margin-left: 10px;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
}

.react-datepicker__time-list {
  max-height: 200px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.react-datepicker__day-name,
.react-datepicker__day {
  width: auto;
  min-width: 65px; /* 요일과 날짜 셀의 너비를 넉넉하게 설정 */
  text-align: center;
}

.react-datepicker__week {
  display: flex;
  justify-content: space-between;
}

/* 네비게이션 화살표 스타일 */
.react-datepicker__navigation {
  width: 35px;
  height: 35px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.react-datepicker__navigation:hover {
  background-color: #e1e7f5;
}

.react-datepicker__navigation-icon::before {
  content: '❮';
  font-size: 1.2rem;
}

.react-datepicker__navigation--next .react-datepicker__navigation-icon::before {
  content: '❯';
}

/* 날짜 셀 스타일 */
.react-datepicker__day,
.react-datepicker__day-name {
  padding: 5px;
  font-size: 0.85rem;
  border-radius: 50%;
}

.react-datepicker__day:hover {
  background-color: #e1e7f5;
}

.react-datepicker__day--selected {
  background-color: #2c5caa;
  color: #fff;
}

.react-datepicker__day--today {
  font-weight: bold;
  color: #2c5caa;
}

/* 시간 리스트 스타일 */
.react-datepicker__time-list-item {
  font-size: 0.9rem;
  padding: 10px;
}

.react-datepicker__time-list-item--selected {
  background-color: #2c5caa;
  color: #fff;
}

.react-datepicker__time-list::-webkit-scrollbar {
  width: 5px;
}

.react-datepicker__day-names {
  display: flex;
  justify-content: space-between;
}

.react-datepicker__header:not(.react-datepicker__header--has-time-select) {
  max-width: 200px;
}

.react-datepicker__time-container .react-datepicker__time {
  max-width: 200px;
  width: fit-content;
}

.react-datepicker__time-container .react-datepicker__time {
  width: 100% !important;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 100% !important;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  height: 40px;
  padding: 10px 10px;
}

.react-datepicker__time-list {
  max-height: fit-content !important;
}

.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 165px;
}

.react-datepicker__day-name, .react-datepicker__day {
  min-width: 40px;
  border-radius: px;
}

/* Mac-like Scrollbar Styles */
* {
  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: #c4c4c4 #f7f9fc; /* Scroll thumb and track */
}

/* Scrollbar styles for WebKit browsers (Chrome, Safari, etc.) */
*::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}

*::-webkit-scrollbar-thumb {
  background-color: #c4c4c4; /* Scroll thumb color */
  border-radius: 6px;
  border: 3px solid #f7f9fc; /* Space around the thumb for smooth appearance */
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #b0b0b0; /* Darker on hover */
}

*::-webkit-scrollbar-track {
  background-color: #f7f9fc; /* Track color */
  border-radius: 6px;
}
`

export default Globalstyle;